export const expandedSidebarWidth = "408px";
export const sidebarExpandButtonWidth = "35px";
